<template>
  <div v-if="pestana == 1">
    <div id="_div" class="w-100 px-5 py-4">
      <div id="Titulo_div">
        <h1>Seguimiento de Citas</h1>

      </div>
      <div style="display: flex">
        <div class="col-12 padding-div-low">
          <div class="area">
            <div class="row" id="formulario">
              <div class="col-2"><span>Estatus de Cita: </span></div>
              <div class="col-4"><span>Periodo:</span></div>
              <div class="col-2"><span>Número de Folio: </span></div>
              <div class="col-2"><span>Nombre / No. Exp: </span></div>

            </div>
            <div class="row">

              <div class="col-2">
                <C012TiposEstatusDeCitas v-on:valorParaElPadre="cambioTipoEstatusDeCita"
                                         :prefijo="enumeraciones.etiquetasDeHTML.Select"
                                         :tipo="enumeraciones.tiposDeSelect.Todos"
                                         :idDelInput="'catalogoTipoEstatusDeCita'"
                                         :parametros="parametros_TipoEstatusDeCita"
                                         :valorDefinido="parametros_TipoEstatusDeCita.ValorDefinido">
                </C012TiposEstatusDeCitas>
              </div>
              <div class="col-2"><input type="date" v-model="FechaInicial" class="form-control" v-on:keyup.enter="buscarCitas" /></div>
              <div class="col-2"><input type="date" v-model="FechaFinal" class="form-control" v-on:keyup.enter="buscarCitas" /></div>
              <div class="col-2"><input type="number" v-model="numeroFolio" class="form-control" v-on:keyup.enter="buscarCitas" min="1" /></div>
              <div class="col-2"><input type="text" v-model="nombreBusqueda" class="form-control" placeholder="Buscar" v-on:keyup.enter="buscarCitas" /></div>
            </div><div class="row">
              <div class="col-10"></div>
              <div class="col-2"><input type="button" class="form-control" @click="buscarCitas" value="Buscar" /></div>
            </div>
            <div class="row new-row">
              <div class="col-10"></div>
              <div class="col-2"><input type="button" class="form-control" @click="generarReporte" value="Generar Reporte"></div>
            </div>
            <div class="row" id="tabla" style="margin-top:20px;">
              <table class="table table-striped table-light table-hover" id="tablaCitas">
                <thead class="thead-dark">
                  <tr class="visible-element">
                    <th>Folio</th>
                    <th>Datos del Solicitante</th>
                    <th>Trámites y Expedientes</th>
                    <th>Fecha y Hora</th>
                    <th>Estatus de Cita</th>
                    <th>Acciones</th>

                  </tr>
                </thead>
                <tbody class='text-dark'>
                  <tr v-for="Cita in Citas">
                    <td>{{Cita.CitaId}}</td>
                    <td>{{Cita.InformacionDeSolicitante.NombreCompleto}}<br />{{Cita.InformacionDeSolicitante.Telefono}}<br />{{Cita.InformacionDeSolicitante.CorreoElectronico}}</td>
                    <td>
                      <ul>
                        <template v-for="Tramite in Cita.TramitesCita">
                          <li>{{Tramite.TipoTramite.Nombre}}.</li>
                          <li style="list-style-type:none"><ul> <li v-for="Expediente in Tramite.Expedientes"> {{Expediente.TipoDocumento_DBPJ.Nombre}} - {{Expediente.NumeroDeExpediente}} </li></ul></li>
                        </template>
                      </ul>

                    </td>
                    <td>{{Cita.AgendaBloque.FechaHoraString}}</td>
                    <td>{{Cita.TipoEstatusDeCita.Nombre}}</td>
                    <td class='d-flex justify-content-around'>
                      <i class="fas fa-book fa-2x" title="Ver historial de cambios." @click="verHistorialCita(Cita.CitaId)" />
                      <i v-if="Cita.BitacoraDeCorreoId != null" class="fas fa-mail-bulk fa-2x" title="Ver historial de cambios." @click="verInformacionDeNotificacionCita(Cita.CitaId)" />
                    </td>
                  </tr>
                  <tr v-if="Citas.length == 0"><td colspan="5">No se encontraron citas pendientes en los siguientes 5 días hábiles.</td></tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
  <div v-else-if="pestana != 1">
    <HistorialDeMovimientosCita :citaId="citaId" v-if="pestana == 2"></HistorialDeMovimientosCita>
    <InformacionDeNotificacionCita :citaId="citaId" v-if="pestana == 3"></InformacionDeNotificacionCita>
    <div class="row">
      <div class="col-10"></div>
      <div class="col-2">
        <input type="button" value="Volver" class="form-control" @click="volverLista" />
      </div>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import store from '@/store/index'
  import HistorialDeMovimientosCita from '@/components/SICCIJ/Recepcion/SeguimientoDeCitas/HistorialDeMovimientosCita.vue'
  import InformacionDeNotificacionCita from '@/components/SICCIJ/Recepcion/SeguimientoDeCitas/InformacionDeNotificacionCita.vue'
  export default {
    data() {
      return {
        enumeraciones,
        catalogos,
        parametros_TipoEstatusDeCita: {
          ValorDefinido: 0,
          TipoEstatusDeCitaId: null
        },
        TipoEstatusDeCita: null,
        nombreBusqueda: "",
        Citas: [],
        NumeroFilasPagina: 10,
        FechaInicial: null,
        FechaFinal: null,
        Hoy: null,
        HorariosDisponibles: [{ "content": "Todo el día.", "value": null }],
        Hora: null,
        FechaBusqueda: null,
        numeroFolio: null,
        citaId: null,
        pestana: 1
      }
    },
    components: {
      C012TiposEstatusDeCitas: catalogos.SICCIJ.C012TiposEstatusDeCitas,
      HistorialDeMovimientosCita,
      InformacionDeNotificacionCita
    },
    methods: {

      buscarCitas: function () { //Retorna una lista de citas en base a ciertos filtros.
        var parts = this.FechaInicial.split("-")
        //this.FechaFinal = new Date(parts[0], parts[1], parts[2]).toISOString().split('T')[0];
        var peticion = {
          "esPrueba": false,
          "NombreBusqueda": this.nombreBusqueda,
          "EstatusCitaId": this.TipoEstatusDeCita,
          "Notificadas": null,
          "FechaInicial": this.FechaInicial,
          "FechaFinal": this.FechaFinal,
          "Hora": null,
          "CargarSoloExpedientesDisponibles": false,
          "NumeroFolio": this.numeroFolio
        };
        console.log(peticion)
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SICCIJ.funciones.GetCitas, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            //console.log(response)
            this.Citas = response.data.Citas
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },      
      generarReporte: function () { //Muestra la tabla de citas en un archivo pdf

        var popupWin = window.open('', '_blank', 'location=no,left=100px');
        popupWin.document.open();
        popupWin.document.write('<html><head><title>Seguimiento de Citas</title>');
        popupWin.document.write('<link rel="" href="/src/assets/favicon.ico">');
        popupWin.document.write('<link href="/static/css/bootstrap.min.css" rel="stylesheet">');
        popupWin.document.write('<link href="/static/css/all.min.css" rel="stylesheet">');
        popupWin.document.write('<link href="/static/css/bootstrap-table.min.css" rel="stylesheet">');
        popupWin.document.write('</head><body >')
        popupWin.document.write('<h2>Seguimiento de Citas ' + this.FechaInicial - this.FechaFinal + '</h2>')

        popupWin.document.write('<table class="table table-striped table-light table-hover" id="tablaCitas">')
        var resultados = document.getElementById('tablaCitas').innerHTML;
        resultados = resultados.split('style="display: none; opacity: 0;"').join('style="opacity: 1; display: table-row;"');
        resultados = resultados.split('style="opacity: 0; display: none;"').join('style="opacity: 1; display: table-row;"');

        popupWin.document.write(resultados);
        popupWin.document.write('</table>');
        popupWin.document.write('</body></html>');
        /*var css = '@page { size: landscape; }',
          head = popupWin.document.head || document.getElementsByTagName('head')[0],
          style = popupWin.document.createElement('style');

        style.type = 'text/css';
        style.media = 'print';

        if (style.styleSheet) {
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(popupWin.document.createTextNode(css));
        }

        head.appendChild(style);
        */
        setTimeout(function () { popupWin.print(); }, 1000)
        popupWin.document.close();
        popupWin.focus();
        this.ImpresionConcluida = true;
      },
      verHistorialCita: function (citaId) {//Redirige a la página SICCIJ/HistorialDeMovimientosCita, paraver el historial de movimientos de la cita.

        this.pestana = 2;
        this.citaId = citaId;
      },
      volverLista: function () {
        this.pestana = 1;
        this.citaId = null;
      },
      verInformacionDeNotificacionCita: function (citaId) {//Redirige a la página SICCIJ/InformacionDeNotificacionCita, paraver la información de notificación de la cita.
        
        this.pestana = 3;
        this.citaId = citaId;
      },
      fijarFechasDefault: function () { //Fija la fecha inicial del formulario como el primer día del mes en curso.
        var date = new Date();
        this.FechaInicial = new Date(date.getFullYear(), date.getMonth(), 1).toISOString().split('T')[0];
        this.FechaFinal = new Date(date.getFullYear(), date.getMonth() + 1, 1).toISOString().split('T')[0];
      },cambioTipoEstatusDeCita(datos) { //Administra los cambios en el componente de Tipo Estatus de Cita.
        catalogos
        //console.log(datos.target);
        this.parametros_TipoEstatusDeCita.TipoEstatusDeCitaId = parseInt(datos.target.value);
        this.TipoEstatusDeCita = (this.parametros_TipoEstatusDeCita.TipoEstatusDeCitaId != 0) ? this.parametros_TipoEstatusDeCita.TipoEstatusDeCitaId : null;
      },
      paginarTabla: function (idTabla) {
        this.$nextTick(() => {
          PaginarTabla(idTabla, this.NumeroFilasPagina)
        })
      }
    }, computed: {

    }, mounted: function mounted() {
      this.fijarFechasDefault();
    }
  }
</script>

<style scoped>
  .padding-div-low {
    padding-top: 40px;
  }

  .fas {
    cursor: pointer;
  }

  .new-row {
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/SICCIJ/Recepcion/SeguimientoDeCitas/SeguimientoDeCitas.vue